module.exports = __webpack_public_path__ + "img/rkas.9c64227c.svg";